<template>
  <div class="wp75">
    <el-form label-width="130px">
      <div class="company-info">
        <div class="display-flex center-flex">
          <img v-if="logoSrc" :src="logoSrc" class="company_pic" alt="">
          <GsMediaPh v-else class="company_pic" label="暂无图片" />
          <div class="company-name">
            <div class="company-title">{{ pageTitle }}</div>
            <div class="company-code">
              <span>所属企业：</span>
              <EnterpriseLink :id="enterpriseId" :name="enterpriseName" />
            </div>
            <div class="display-flex">
              <div
                v-for="(item, index) in tagList"
                :key="index"
                class="data-item mr10"
              >
                <span :class="index < 1 ? 'info-btn' : 'info-last'">{{ item }}</span>
              </div>
            </div>
          </div>
        </div>
        <div class="bg mt10">
          <el-form-item label-width="120px" :label="isDemand ? '需求描述：' : '服务内容：'">
            <div v-if="introText">{{ introText }}</div>
            <div v-else class="gs-text-ph">{{ introPlaceholder }}</div>
          </el-form-item>
        </div>
      </div>
      <div class="form-card">
        <TitleTool title="入驻信息" />
        <ListingCard
          :company="company"
          :business-options="labelList"
          :is-demand="isDemand"
          :enterprise-id="enterpriseId"
          :enterprise-name="enterpriseName"
          variant="dialog"
        />
      </div>
    </el-form>
  </div>
</template>

<script>
import { enterpriseInfoDetail, getListingDetail } from '@/api/Home'
import { getDataType } from '@/api/Layout/index.js'
import { enumType } from '@/utils/enum.js'
import { routeId } from '@/router/paths'
import ListingCard from '@/components/ListingCard/index.vue'
import GsMediaPh from '@/components/GsMediaPh/index.vue'
import EnterpriseLink from '@/components/EnterpriseLink/index.vue'

export default {
  name: 'ListingDetailView',
  components: { ListingCard, GsMediaPh, EnterpriseLink },
  data() {
    return {
      company: {},
      enterprise: {},
      labelList: [],
      prodUrl: 'https://shujuzichan.com/xwzx'
    }
  },
  computed: {
    isDemand() {
      if (this.$route.meta && this.$route.meta.listType === 1) return true
      return String(this.company.listingType) === '6'
    },
    pageTitle() {
      return this.company.companyName || '未命名入驻'
    },
    enterpriseId() {
      return this.company.enterpriseId || (this.enterprise && this.enterprise.id) || ''
    },
    enterpriseName() {
      return this.enterprise.enterpriseName || this.enterprise.enterpriseAbbreviation || ''
    },
    logoSrc() {
      const src = this.enterprise.logoPicture || ''
      if (!src) return ''
      if (/^https?:\/\//i.test(src)) return src
      return this.prodUrl + src
    },
    introText() {
      return (this.company.requireMent || '').toString().trim()
    },
    introPlaceholder() {
      return this.isDemand
        ? '该入驻暂未公开需求描述。'
        : '该入驻暂未公开服务内容。'
    },
    industryLabel() {
      const value = this.company.businessType
      if (!value) return ''
      const hit = (this.labelList || []).find((item) => String(item.value) === String(value))
      return (hit && hit.label) || value
    },
    tagList() {
      return [
        this.isDemand ? '需求方' : '服务商',
        this.industryLabel,
        this.company.address
      ].filter((item) => item && String(item).trim())
    }
  },
  created() {
    this.getData('sys_business_type')
    this.loadDetail()
  },
  watch: {
    '$route.params.id'() {
      this.loadDetail()
    }
  },
  methods: {
    async getData(type) {
      try {
        const res = await getDataType(type)
        if (res && res.data && res.data.length > 0 && type === 'sys_business_type') {
          this.labelList = enumType(res.data)
        }
      } catch (error) {
        console.error('Error fetching data:', error)
      }
    },
    loadDetail() {
      const id = routeId(this.$route)
      if (!id) return
      getListingDetail(id).then((res) => {
        this.company = (res && res.data) || {}
        const enterpriseId = this.company.enterpriseId
        if (!enterpriseId) {
          this.enterprise = {}
          return
        }
        enterpriseInfoDetail(enterpriseId).then((ent) => {
          this.enterprise = (ent && ent.data) || {}
        }).catch(() => {
          this.enterprise = {}
        })
      })
    }
  }
}
</script>

<style scoped lang="css">
.company-info {
  margin: 10px auto;
  position: relative;
  background: linear-gradient(180deg, #FFFFFF 0%, #F6F9FF 100%);
  border-radius: 8px;
  padding: 10px;
}
.company_pic {
  width: 106px;
  height: 106px;
  border-radius: 10px;
  margin-right: 20px;
  overflow: hidden;
  object-fit: cover;
  flex-shrink: 0;
}
.company-title {
  min-height: 36px;
  font-size: 32px;
  color: #111824;
  line-height: 36px;
  font-weight: 700;
  margin-bottom: 10px;
}
.company-code {
  display: flex;
  align-items: center;
  height: 22px;
  font-size: 16px;
  color: #333333;
  line-height: 22px;
  margin-bottom: 10px;
}
.data-item {
  height: 14px;
  font-size: 12px;
  color: #0165FF;
  line-height: 14px;
  text-align: center;
}
.info-btn {
  background: #D6E5FE;
  border-radius: 4px;
  padding: 4px 6px;
}
.info-last {
  background: #E2E2E2;
  border-radius: 4px;
  color: #333333;
  padding: 4px 6px;
}
.bg {
  background: #FFFFFF;
  border-radius: 8px;
}
.form-card {
  background-color: rgba(75, 145, 255, .07);
  border-radius: 4px;
  padding: 20px 10px;
  margin-bottom: 24px;
}
.little-title {
  display: flex;
  align-items: center;
  font-weight: 700;
  font-size: 20px;
  color: #111824;
  line-height: 24px;
}
.icon-title {
  width: 28px;
  height: 18px;
  margin-right: 8px;
}
.gs-text-ph {
  flex: 1;
  min-width: 0;
  padding: 10px 12px;
  border-radius: 8px;
  background: linear-gradient(90deg, #F4F8FF 0%, #FFFFFF 100%);
  border: 1px dashed #C5D8F7;
  color: #7B8BA3;
  font-size: 13px;
  line-height: 22px;
}
.el-form-item {
  margin-bottom: 0;
}
::v-deep .el-form-item__label {
  font-size: 16px;
  color: #333333;
  line-height: 40px;
}
::v-deep .el-form-item__content {
  font-size: 16px;
  color: #666666;
  line-height: 40px;
}
@media (max-width: 960px) {
  .company-info {
    padding: 12px;
  }
  .company-info > .display-flex {
    flex-wrap: wrap;
    align-items: flex-start;
    gap: 10px;
  }
  .company_pic {
    width: 72px;
    height: 72px;
    margin-right: 12px;
  }
  .company-title {
    font-size: 18px;
    line-height: 1.3;
    min-height: 0;
  }
  .company-code {
    height: auto;
    font-size: 12px;
    line-height: 18px;
    flex-wrap: wrap;
  }
  .form-card {
    padding: 12px 8px;
  }
  ::v-deep .el-form-item {
    display: flex;
    flex-direction: column;
    align-items: stretch;
    margin-bottom: 10px;
  }
  ::v-deep .el-form-item__label {
    width: auto !important;
    text-align: left;
    line-height: 1.35;
    height: auto;
    padding: 0 0 2px;
    font-size: 12px;
    color: #64748b;
  }
  ::v-deep .el-form-item__content {
    margin-left: 0 !important;
    font-size: 13px;
    line-height: 1.45;
  }
  ::v-deep .el-col {
    max-width: 100% !important;
    flex: 0 0 100% !important;
  }
}
</style>
